import React, {Component} from "react";

import AsyncStorage from '@react-native-community/async-storage';

import store from "../redux/store";
//import {serviceActionSetToken} from "../redux/actions/ActionSplashGetAllData";
import i18n from './../I18n/i18n.js';
//import {serviceActionAccount} from "../redux/actions/satia/ActionSplashSatiaScreen";
import {typeExport} from "../redux/store/type";
import {
    serviceActionAccount,
    serviceActionSetToken,
    serviceActionSetUser
} from "../screens/satia/splash/action/ActionSplashSatiaScreen";

import {
    serviceActionSetNameDynamic,

    serviceActionSetToken as serviceActionSetToken137,
    serviceActionSetTokenLaravel,
    serviceActionSetTokenMahaleh,
    serviceActionSetTypeLogin,
    serviceActionSetUser as serviceActionSetUser137,
    serviceActionSuccessShahrdar
} from "../screens/137/splash/action/ActionSplashGetAllData";

export class AsyngStorageClass extends Component {
    static async getIdCity() {

        try {
            const value = JSON.parse(await AsyncStorage.getItem(IDCITY));
            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;
        }
    }

    static async selectcity(id_state, name_state, id_city, name_city, props) {
        try {
            await AsyncStorage.setItem(typeExport.IDSTATE, JSON.stringify(id_state));
            await AsyncStorage.setItem(typeExport.NAMESTATE, JSON.stringify(name_state));
            await AsyncStorage.setItem(typeExport.IDCITY, JSON.stringify(id_city));
            await AsyncStorage.setItem(typeExport.NAMECITY, JSON.stringify(name_city));
            return true;
        } catch (error) {
            console.log("ASY", error)
            return false;
        }
    }

    static async exitApp() {
        try {
            await AsyncStorage.removeItem(typeExport.TOKEN);
            await AsyncStorage.removeItem(typeExport.NATIONALCOD);
            await AsyncStorage.removeItem(typeExport.NAME);
            await AsyncStorage.removeItem(typeExport.MOBILE);
            return true;

        } catch (error) {
            console.log("ASY", error)
            return false;
        }
    }

    static async getAllAsyncStorage() {
        value = {
            id_state: 0,
            name_state: "",
            id_city: 0,
            name_city: "",
            token: null
        }
        try {
            value.token = JSON.parse(await AsyncStorage.getItem(typeExport.TOKEN));
            value.id_state = JSON.parse(await AsyncStorage.getItem(typeExport.IDSTATE));
            value.name_state = JSON.parse(await AsyncStorage.getItem(typeExport.NAMESTATE));
            value.id_city = JSON.parse(await AsyncStorage.getItem(typeExport.IDCITY));
            value.name_city = JSON.parse(await AsyncStorage.getItem(typeExport.NAMECITY));
            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }

    static async checkToken() {
        try {

            const value = JSON.parse(await AsyncStorage.getItem(typeExport.TOKEN));

            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;
        }
    }

    static async setInfoUser(token, address, name) {
        try {
            await AsyncStorage.setItem(typeExport.TOKEN, JSON.stringify(token));
            await AsyncStorage.setItem(typeExport.NATIONALCOD, JSON.stringify(address));
            await AsyncStorage.setItem(typeExport.NAME, JSON.stringify(name));

            return true;
        } catch (error) {
            console.log("ASY", error);
            return false;
        }
    }

    static async setToken(token) {
        try {
            await AsyncStorage.setItem(typeExport.TOKEN, JSON.stringify(token));

            return true;
        } catch (error) {
            console.log("ASY", error);
            return false;
        }
    }

    static async setInfoUserMobile(mobile) {
        try {

            await AsyncStorage.setItem(typeExport.MOBILE, JSON.stringify(mobile));
            return true;
        } catch (error) {
            console.log("ASY", error);
            return false;
        }
    }

    static async setRtl(data) {
        try {

            await AsyncStorage.setItem(typeExport.Rtl, JSON.stringify(data));
            // if (data) {
            //     // await AsyncStorage.setItem(SideMenu, [{SideMenu: "RightSideMenu"}, {SideMenuClose: "RightSideMenuClose"}, {SideMenuToggle: "RightSideMenuToggle"}]);
            //     await AsyncStorage.setItem(SideMenu, "RightSideMenu");
            //     await AsyncStorage.setItem(SideMenuClose, "RightSideMenuClose");
            //     await AsyncStorage.setItem(SideMenuToggle, "RightSideMenuToggle");
            //
            // }
            // else {
            //     //  await AsyncStorage.setItem(SideMenu, [{SideMenu: "LeftSideMenu"}, {SideMenuClose: "LeftSideMenuClose"}, {SideMenuToggle: "LeftSideMenuToggle"}]);
            //
            //     await AsyncStorage.setItem(SideMenu, "LeftSideMenu");
            //     await AsyncStorage.setItem(SideMenuClose, "LeftSideMenuClose");
            //     await AsyncStorage.setItem(SideMenuToggle, "LeftSideMenuToggle");
            //
            //
            // }
            return true;
        } catch (error) {
            console.log("ASY", error);
            return false;
        }
    }

    static async getRtl() {
        let value = null;
        try {
            value = JSON.parse(await AsyncStorage.getItem(Rtl));


            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }

    static async setLang(data) {

        try {
            await AsyncStorage.setItem(typeExport.LANG, data);

            return true;
        } catch (error) {
            console.log("ASY", error);
            return false;
        }
    }

    static async getLang() {
        let value = null;
        try {
            value = await AsyncStorage.getItem(typeExport.LANG);

            if (value === null || value === "null" || value === undefined)
                return 'en';

            return value;
        } catch (error) {
            console.log("ASY", error)
            return 'en';

        }
    }

    static async setImageSplash(data) {

        try {
            await AsyncStorage.setItem(typeExport.ImageSplash, data);

            return null;
        } catch (error) {
            console.log("ASY", error);
            return null;
        }
    }

    static async getImageSplash() {
        let value = null;
        try {
            value = await AsyncStorage.getItem(typeExport.ImageSplash);
            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }

    static async setImageBackground(data) {

        try {
            await AsyncStorage.setItem(typeExport._ImageBackground, data);

            return null;
        } catch (error) {
            console.log("ASY", error);
            return null;
        }
    }

    static async getImageBackground() {
        let value = null;
        try {
            value = await AsyncStorage.getItem(typeExport._ImageBackground);
            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }

    static async getSideMenu() {
        // let value = [{SideMenu: "RightSideMenu"}, {SideMenuClose: "RightSideMenuClose"}, {SideMenuToggle: "RightSideMenuToggle"}];
        let value = "RightSideMenu";
        try {
            value = JSON.parse(await AsyncStorage.getItem(typeExport.SideMenu));


            return value;
        } catch (error) {
            console.log("ASY", error)
            return value;

        }
    }

    static async getSideMenuClose() {
        // let value = [{SideMenu: "RightSideMenu"}, {SideMenuClose: "RightSideMenuClose"}, {SideMenuToggle: "RightSideMenuToggle"}];
        let value = "RightSideMenuClose";
        try {
            value = JSON.parse(await AsyncStorage.getItem(typeExport.SideMenuClose));


            return value;
        } catch (error) {
            console.log("ASY", error)
            return value;

        }
    }

    static async getSideMenuToggle() {
        // let value = [{SideMenu: "RightSideMenu"}, {SideMenuClose: "RightSideMenuClose"}, {SideMenuToggle: "RightSideMenuToggle"}];
        let value = "RightSideMenuToggle";
        try {
            value = JSON.parse(await AsyncStorage.getItem(typeExport.SideMenuToggle));


            return value;
        } catch (error) {
            console.log("ASY", error)
            return value;

        }
    }

    static async getAllInformationUser() {
        value = {
            address: "",
            name: "",
            mobile: "",
        }
        try {
            value.address = JSON.parse(await AsyncStorage.getItem(typeExport.NATIONALCOD));
            value.name = JSON.parse(await AsyncStorage.getItem(typeExport.NAME));
            value.mobile = JSON.parse(await AsyncStorage.getItem(typeExport.MOBILE));

            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }


    static async setAsyng(type, data) {

        try {
            await AsyncStorage.setItem(type, JSON.stringify(data));
            // await AsyncStorage.setItem(type,data);

            return null;
        } catch (error) {
            console.log("ASY", error);
            return null;
        }
    }

    static async getASyng(type) {
        let value = null;
        try {
            value = await AsyncStorage.getItem(type);


            if (value !== null) {
                // We have data!!
                //  const value = JSON.parse(value);
                value = JSON.parse(value.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())


            }
            return value;
        } catch (error) {
            console.log("ASY", error)
            return null;

        }
    }

    static async removeToken(type) {
        if (typeExport._TypeApp === "Satia") {
            store.dispatch(serviceActionSetToken(null))
            store.dispatch(serviceActionSetUser(null))
            store.dispatch(serviceActionAccount(null))
            try {
                //   await AsyncStorage.removeItem(typeExport.TOKEN);
                //await AsyngStorageClass.setAsyng("Account", null);
                await AsyncStorage.removeItem("Account");
                await AsyncStorage.removeItem(typeExport._USER);
                await AsyncStorage.removeItem(typeExport.TOKEN);
            } catch (error) {
                alert(i18n.t('constant.retry'))
            }
        }
        else {
            try {
                //   await AsyncStorage.removeItem(typeExport.TOKEN);
                //await AsyngStorageClass.setAsyng("Account", null);
                await AsyncStorage.removeItem(typeExport._USER);
                await AsyncStorage.removeItem(typeExport.TOKEN);
                store.dispatch(serviceActionSetToken(null));
                await AsyncStorage.removeItem("tokenMahaleh");
                store.dispatch(serviceActionSetTokenMahaleh(null));
                await AsyncStorage.removeItem("tokenLaravel");
                store.dispatch(serviceActionSetTokenLaravel(null));

                await AsyncStorage.removeItem(typeExport._TypeLogin);
                store.dispatch(serviceActionSetTypeLogin(null));

                await AsyncStorage.removeItem("City");
                store.dispatch(serviceActionSetNameDynamic("City",null));

                await AsyncStorage.removeItem("OrganCity");
                store.dispatch(serviceActionSetNameDynamic("OrganCity",null));

            } catch (error) {
                alert(i18n.t('constant.retry'))
            }
            store.dispatch(serviceActionSetToken137(null))
            store.dispatch(serviceActionSetUser137(null))
            if (type === typeExport._Shahrdar) {
                store.dispatch(serviceActionSuccessShahrdar(null))
                //store.dispatch(serviceActionSetTypeLogin(1))
            }


        }

    }
}
